import { FormRows } from '@acorns/web-components'
import * as Sentry from '@sentry/browser'
import format from 'date-fns/format'

import { ActionType, PageName } from 'generated/types'
import { sendToSentry } from 'utils/errors'
import { FlowRoute } from 'utils/FlowProvider/types'
import { displayErrorModal, parseGraphQLError } from 'utils/form-utils'
import { getGeneralError } from 'utils/getGeneralError'
import { updateExtolePerson } from 'utils/referral'
import { dobMask } from 'utils/text-masks/dob'

// Backend expects YYYY/MM/DD
const formatDob = dob => format(dob, 'YYYY/MM/DD')

export const handleSubmit = (values, { props, ...ownProps }) => {
  ownProps.setSubmitting(true)
  Sentry.addBreadcrumb({ message: 'User attempting to submit personal info at /personal-info' })
  const variables = {
    ...values,
    dob: formatDob(values.dob),
  }

  return props
    .updatePersonalInfo({ variables })
    .then(() => {
      updateExtolePerson(props.env, values.firstName, values.lastName).then(() => {
        props.isDynamicFunnelEnabled
          ? props.routeToPage(PageName.PersonalInfo, ActionType.Continue)
          : props.route({ from: FlowRoute.PersonalInfo, action: 'continue' })
      })
    })
    .catch(error => {
      const retryHandler = () => {
        props.closeErrorModal()
        ownProps.submitForm()
      }
      const { title, message, actions, image } = getGeneralError(error, props, retryHandler)
      props.showErrorModal({ title, message, actions, image })

      sendToSentry(error)
      ownProps.setSubmitting(false)
      const errorCode = parseGraphQLError(error)

      displayErrorModal(props, errorCode, {})
    })
}

export default [
  [
    {
      label: 'Legal First Name *',
      name: 'firstName',
      type: 'text',
      placeholder: 'John',
    },
    {
      label: 'Legal Last Name *',
      name: 'lastName',
      type: 'text',
      placeholder: 'Doe',
    },
  ],
  [
    {
      label: 'Birthday *',
      name: 'dob',
      mask: dobMask,
      placeholder: 'MM/DD/YYYY',
      type: 'text',
      guide: false,
    },
  ],
  [
    {
      label: "I'm a U.S. Citizen",
      name: 'usCitizen',
      topLabel: 'Citizenship *',
      sizes: { sm: 12, md: 12, xs: 12 },
      type: 'checkbox',
    },
  ],
] as FormRows
